class OnlineQueueRunner {
    /**
     * @param {ConnectivityChecker} connectivityChecker
     * @param {OnlineQueue} onlineQueue
     */
    constructor(
        connectivityChecker,
        onlineQueue
    ) {
        this.connectivityChecker = connectivityChecker;
        this.onlineQueue = onlineQueue;
    }

    /**
     * @return {Promise}
     */
    async runWithOnlineCheck() {
        let isOnline = await this.connectivityChecker.check();
        if (!isOnline) {
            return Promise.reject(new Error('Not online.'));
        }
        return this.runNextInQueue();
    }

    /**
     * @return {Promise}
     */
    runWithoutOnlineCheck() {
        return this.runNextInQueue();
    }

    /**
     * @private
     *
     * @return {Promise}
     */
    runNextInQueue() {
        return this.onlineQueue.getNextTask()
            .then((task) => {
                if (!task) {
                    this.onlineQueue.log.debug('Nothing to run');
                    return null;
                }

                return this.onlineQueue.runTask(task)
                    .then(() => {
                        // Run the next item in the queue if this task succeeds.
                        // finally() isn't suitable here because you can't return a new promise from finally.
                        return this.runWithOnlineCheck();
                    })
                    .catch(() => {
                        // Run the next item in the queue if this task fails.
                        return this.runWithOnlineCheck();
                    });
            });
    }
}

module.exports = OnlineQueueRunner;
